// CAT Mock 7 — QA section.
const catMock7Qa = [
  {
    id: 47,
    type: "mcq",
    question: "What is the compound interest on ₹10,000 at 10% per annum, compounded annually, for 3 years?",
    options: [
      "A. ₹3,000",
      "B. ₹3,100",
      "C. ₹3,310",
      "D. ₹3,210"
    ],
    answer: "C"
  },
  {
    id: 48,
    type: "tita",
    question: "Pipe A can fill a tank in 12 hours and pipe B in 15 hours, while pipe C can empty the full tank in 20 hours. If all three pipes are opened together on an empty tank, in how many hours will the tank be full?",
    answer: "10"
  },
  {
    id: 49,
    type: "mcq",
    question: "The HCF of two numbers is 12 and their LCM is 360. If one of the numbers is 72, what is the other?",
    options: [
      "A. 60",
      "B. 48",
      "C. 90",
      "D. 72"
    ],
    answer: "A"
  },
  {
    id: 50,
    type: "tita",
    question: "The average of 11 numbers is 30. The average of the first six numbers is 28 and the average of the last six numbers is 34. What is the sixth number?",
    answer: "42"
  },
  {
    id: 51,
    type: "mcq",
    question: "A shopkeeper marks an article 40% above its cost price and then sells it at a discount of 15% on the marked price. What is the profit percentage?",
    options: [
      "A. 25%",
      "B. 21%",
      "C. 17%",
      "D. 19%"
    ],
    answer: "D"
  },
  {
    id: 52,
    type: "tita",
    question: "If log₂(x) + log₂(x − 2) = 3, what is the value of x?",
    answer: "4"
  },
  {
    id: 53,
    type: "mcq",
    question: "The sum of an infinite geometric progression is 18 and its first term is 12. What is its common ratio?",
    options: [
      "A. 1/2",
      "B. 1/3",
      "C. 2/3",
      "D. 1/4"
    ],
    answer: "B"
  },
  {
    id: 54,
    type: "tita",
    question: "How many zeros are there at the end of 125! (125 factorial)?",
    answer: "31"
  },
  {
    id: 55,
    type: "mcq",
    question: "Two fair dice are thrown together. What is the probability that the sum of the numbers shown is 8?",
    options: [
      "A. 1/6",
      "B. 7/36",
      "C. 5/36",
      "D. 1/9"
    ],
    answer: "C"
  },
  {
    id: 56,
    type: "tita",
    question: "In how many distinct ways can the letters of the word LEVEL be arranged?",
    answer: "30"
  },
  {
    id: 57,
    type: "mcq",
    question: "A circle is inscribed in a square of side 14 cm. What is the area of the region inside the square but outside the circle? (Take π = 22/7.)",
    options: [
      "A. 42 sq cm",
      "B. 56 sq cm",
      "C. 49 sq cm",
      "D. 38.5 sq cm"
    ],
    answer: "A"
  },
  {
    id: 58,
    type: "tita",
    question: "A car travels from town X to town Y at 60 km/h and returns along the same route at 40 km/h. What is its average speed for the whole journey (in km/h)?",
    answer: "48"
  },
  {
    id: 59,
    type: "mcq",
    question: "If x + 1/x = 5, what is the value of x² + 1/x²?",
    options: [
      "A. 25",
      "B. 27",
      "C. 21",
      "D. 23"
    ],
    answer: "D"
  },
  {
    id: 60,
    type: "tita",
    question: "What is the sum of the first 20 terms of the arithmetic progression whose first term is 3 and common difference is 4?",
    answer: "820"
  },
  {
    id: 61,
    type: "mcq",
    question: "A 40-litre mixture contains milk and water in the ratio 5 : 3. How many litres of water must be added to make the ratio 1 : 1?",
    options: [
      "A. 8 litres",
      "B. 10 litres",
      "C. 12 litres",
      "D. 15 litres"
    ],
    answer: "B"
  },
  {
    id: 62,
    type: "tita",
    question: "How many integers x satisfy |x − 3| ≤ 5?",
    answer: "11"
  },
  {
    id: 63,
    type: "mcq",
    question: "A man spends 75% of his income. His income rises by 20% and his expenditure rises by 10%. By what percentage do his savings increase?",
    options: [
      "A. 40%",
      "B. 45%",
      "C. 50%",
      "D. 30%"
    ],
    answer: "C"
  },
  {
    id: 64,
    type: "tita",
    question: "What is the remainder when 2¹⁰⁰ is divided by 7?",
    answer: "2"
  },
  {
    id: 65,
    type: "mcq",
    question: "How many diagonals does a convex polygon with 10 sides have?",
    options: [
      "A. 35",
      "B. 45",
      "C. 40",
      "D. 30"
    ],
    answer: "A"
  },
  {
    id: 66,
    type: "tita",
    question: "How many integers from 1 to 300 (both inclusive) are divisible by 3 or by 5, but not by 15?",
    answer: "120"
  },
  {
    id: 67,
    type: "mcq",
    question: "What is the minimum value of x² − 8x + 21 for real x?",
    options: [
      "A. 3",
      "B. 4",
      "C. 6",
      "D. 5"
    ],
    answer: "D"
  },
  {
    id: 68,
    type: "tita",
    question: "Two runners start from the same point on a circular track of length 600 m and run in opposite directions at 5 m/s and 7 m/s. After how many seconds will they meet for the first time?",
    answer: "50"
  }
];

export default catMock7Qa;
